import React from 'react';
import Typography from '@mui/material/Typography';
import BackButton from 'components/BackButton/BackButton';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { BUDGET_HOME_PAGE_URL } from 'components/App/components/routes';
import { BAR_STYLES } from './helpers/constants';

type OperationFooterProps = {
    operationName: string;
};

const StyBottomBar = styled(Box, {
    name: 'StyHeader',
})({
    position: 'sticky',
    bottom: 0,
    boxShadow: '4px 8px 24px rgba(0, 0, 0, 0.35)',
    ...BAR_STYLES,
});

export default function OperationFooter(
    props: OperationFooterProps,
): React.ReactElement {
    const { operationName } = props;
    const onClick = () => {
        trackEventBudget(
            TRACKABLE_EVENTS.budget.general.operation360.backButtonClick,
        );
    };
    return (
        <StyBottomBar>
            <Typography variant="body1SemiBold">{operationName}</Typography>
            <BackButton
                defaultReturn={BUDGET_HOME_PAGE_URL}
                onClick={onClick}
            />
        </StyBottomBar>
    );
}
